module.exports = __webpack_public_path__ + "img/img_inspection@2x.5f02b4e5.png";